import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { PaysheetManager } from 'src/app/classes/paysheet-manager';
import { environment } from 'src/environments/environment';
import { DriverService } from 'src/app/services/driver.service';
import { Plants } from 'src/app/models/plants';
import * as _ from 'lodash';

@Component({
  selector: 'app-paysheet-report',
  templateUrl: './paysheet-report.component.html',
  styleUrls: ['./paysheet-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PaysheetReportComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data:any = {data:[], total: 0};
  dataAll:any = {data:[], total: 0};
  loading:boolean = false;
  total:number = 0;
  plantId:number = 1; //NMH
  plants:Plants[] = [];

  constructor(private repServ:ReportService, private paysheetManager:PaysheetManager, private driverService:DriverService) { 
    this.date1.setDate(this.date1.getDate() - 6);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.driverService.getAllPlants().then(respose => {
      this.plants = _.orderBy(_.filter(respose, (p) => { return p.status; }), ['id'], ['asc']);
    });
    this.repServ.paysheetReport(this.date1, this.date2).then(resp => {
      this.dataAll = resp;
      this.getFilterByPlant(this.dataAll);
      this.data = this.paysheetManager.calculate(resp);
      this.loading = false;
    });
  }

  getFilterByPlant(dataAll:any[]){
    let tempData = [];
    _.forEach(dataAll, (d) => {
      if(d.plant == this.plantId)
        tempData.push(d);
    });
    this.data = tempData;
  }
  
  getFilter(){
    this.loading = true;
    this.getFilterByPlant(this.dataAll);
    this.data = this.paysheetManager.calculate(this.data);
    this.loading = false;
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/paysheet?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + '&plant=' + this.plantId, '_blank');
  }

}
